/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Row, Button, ButtonToolbar, ButtonGroup, Col } from 'reactstrap';

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import {AppContext} from '../../AppContext';

class UserLoginHistory extends React.Component
{
  columnKey = 'userLoginHistory.columnWidths';
  columnWidths = {};
  debouncedSaveColumnWidths = null;

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.columnKey);
    this.getLoginHistory();
  }

  constructor(props)
  {
    super();

    let columns = 
    [
      { Header: 'Start', id: 'sessionCreated', accessor: d => {return d.sessionCreated},
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.sessionCreated, true)}>{window.formatTimestamp(rowInfo.row.sessionCreated, false)}</span></div>)
      },
      { Header: 'End', id: 'sessionEnded', accessor: d => {return d.sessionEnded},
        Cell: rowInfo => null !== rowInfo.row.sessionEnded ? 
          (<div><span title={window.formatTimestamp(rowInfo.row.sessionEnded, true)}>{window.formatTimestamp(rowInfo.row.sessionEnded, false)}</span></div>) :
          (<div></div>)
      },
      { Header: 'Last Activity', id: 'lastActivity', accessor: d => {return d.lastActivity},
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.lastActivity, true)}>{window.formatTimestamp(rowInfo.row.lastActivity, false)}</span></div>)
      },
      { Header: 'IP Address', id: 'ipAddress', accessor: 'clientAddress', Cell: row => <div><span title={row.value}>{row.value}</span></div> },
      { Header: 'Status', id: 'status', accessor: 'sessionStatus', Cell: row => <div><span title={row.value}>{row.value}</span></div> },
      { Header: 'Disposition', id: 'disposition', accessor: 'sessionDisposition', Cell: row => <div><span title={row.value}>{row.value}</span></div> },
      { Header: 'Terminated By', id: 'terminator', accessor: 'terminatedBy', Cell: row => <div><span title={row.value}>{row.value}</span></div> },
      { Header: 'User Agent', id: 'userAgent', accessor: 'userAgent', Cell: row => <div><span title={row.value}>{row.value}</span></div> }
    ];

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);
    
    this.getLoginHistory = this.getLoginHistory.bind(this);

    this.state =
    {
      loginHistory: undefined,
      columns: columns
    }
  }

  async getLoginHistory()
  {
    let bodyData = {};
    bodyData.username = this.props.username;

    let result = await this.context.dbTwig.callRestAPI('icam', 'getLoginHistoryForUser', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving login history');
    this.setState({ loginHistory: result.jsonData.loginHistory });
  }

  render()
  {
    return (
      <div>
        <Col>
          <Row style={{paddingTop: "10px" }}>
            <ButtonToolbar>
              <ButtonGroup size="sm">
                <Button style={{backgroundColor: 'transparent'}} title="Refresh" onClick={this.getLoginHistory}><img src="assets/images/refresh.png" alt="Refresh" /></Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Row>
          <Row>
            <ReactTable data={this.state.loginHistory} showPagination={true} columns={this.state.columns} minRows={1} className="-highlight"
              NoDataComponent={this.noDataComponent} defaultPageSize={15} pageSizeOptions={[5, 10, 15, 20, 30, 50, 100]}
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)}
            />
          </Row>
        </Col>
      </div>
    );
  }

  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.columnKey);    
  }
}

UserLoginHistory.contextType = AppContext;

export default UserLoginHistory